// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TD0xI{position:fixed;top:0;left:0;right:0;bottom:0;z-index:100;display:flex;align-items:center;justify-content:center;padding:64px;overflow:hidden}.TD0xI::after{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background:var(--vob-bg-image) center/cover no-repeat;opacity:1;transition:opacity .8s ease;pointer-events:none}.TD0xI::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(40,40,107,.25);backdrop-filter:blur(4px);opacity:0;transition:opacity .8s ease;pointer-events:none;z-index:1}.TD0xI.sO82O::before{opacity:1}.TD0xI.GiXMJ{padding:32px}.TD0xI.n8EiW{padding:0}.TD0xI.n8EiW::after{background:#fff}.TD0xI.sO82O.n8EiW::after{background:#1a1a2e;opacity:1}.TD0xI.sO82O.n8EiW::before{display:none}.xe9XV{width:100%;height:100%;background:#fff;border-radius:16px;overflow:hidden;position:relative;z-index:2;border:1px solid #d4d4e0;box-shadow:0px 4px 12px rgba(40,40,99,.06)}.n8EiW .xe9XV{border:none;border-radius:0;box-shadow:none}.SaOE8{width:50%;min-width:320px;display:flex;flex-direction:column;gap:24px}.SaOE8.PwC1g{width:90%;height:100%}.SaOE8.BZ6JZ{align-self:flex-start}.SaOE8.BZ6JZ .DuOAA{margin-top:120px}.DuOAA{display:flex;flex-direction:column;align-items:center;gap:8px;text-align:center;margin-bottom:8px}.lIPyZ{color:#1d1f3d;white-space:nowrap}@media(max-width: 640px){.SaOE8{width:100%;min-width:0;padding:0 24px;box-sizing:border-box}.lIPyZ{white-space:normal}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `TD0xI`,
	"dashboardBackground": `sO82O`,
	"tablet": `GiXMJ`,
	"mobile": `n8EiW`,
	"card": `xe9XV`,
	"animatedStep": `SaOE8`,
	"fullWidthStep": `PwC1g`,
	"topAligned": `BZ6JZ`,
	"titleBlock": `DuOAA`,
	"title": `lIPyZ`
};
export default ___CSS_LOADER_EXPORT___;
